
import React from 'react'
import { Divider } from '@material-ui/core'
import { ChangeEmail } from './ChangeEmail'


export const EmailAndPassword = () => {

    return (
        <>
        <div className='text-body margin-top-basic blue bolder'>Email</div>
        <Divider />
        <ChangeEmail />

        {/* <div className='text-body margin-top-basic blue bolder'>Password</div>
        <Divider /> */}
        </>
    )
}